module.exports = __webpack_public_path__ + "img/img5.8e8bd5f7.png";